export enum MediumType {
    Physical = 1,
    Mobile = 2
}